// import React, {forwardRef, useImperativeHandle, useRef} from 'react';
// import {Doughnut} from 'react-chartjs-2';
// import {Chart as ChartJS, ArcElement, Tooltip, Legend} from 'chart.js';
// import {PDFExport} from '@progress/kendo-react-pdf';
// import {dojahIcon, pdfBg} from 'assets/images/images';

// ChartJS.register(ArcElement, Tooltip, Legend);

// const FlowOverviewReport = forwardRef(({accountData = {}}, ref) => {
//   const pdfExportComponent = useRef(null);

//   useImperativeHandle(ref, () => ({
//     handleExportWithComponent: () => {
//       if (pdfExportComponent.current) {
//         pdfExportComponent.current.save();
//       }
//     },
//   }));

//   const eventsData = {
//     labels: ['Resolved', 'Unresolved'],
//     datasets: [
//       {
//         data: [48, 52],
//         backgroundColor: ['#141738', '#3F7CDB'],
//         borderWidth: 0,
//         borderRadius: 30,
//         spacing: 5,
//         rotation: -90,
//         circumference: 360,
//       },
//     ],
//   };

//   const casesData = {
//     labels: ['Allowed', 'Blocked'],
//     datasets: [
//       {
//         data: [30, 70],
//         backgroundColor: ['#F3787A', '#A13E3F'],
//         borderWidth: 0,
//         borderRadius: 30,
//         spacing: 5,
//         rotation: -90,
//         circumference: 360,
//       },
//     ],
//   };

//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     cutout: '75%',
//     plugins: {
//       legend: {
//         display: false,
//       },
//       tooltip: {
//         enabled: false,
//       },
//     },
//     hover: {
//       mode: null,
//     },
//     events: [],
//   };

//   const Header = () => (
//     <div
//       className=" "
//       style={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         marginBottom: '10px',
//         fontSize: '12px',
//         zIndex: 1,
//       }}
//     >
//       <div style={{display: 'flex', alignItems: 'center'}}>
//         <img src={dojahIcon} alt="Dojah Logo" width={24} height={20} />
//       </div>
//       <div style={{textAlign: 'right'}}>
//         <div style={{color: '#4A4A68', fontStyle: 'italic'}}>
//           Generated by Dojah
//         </div>
//         <div style={{color: '#727272', fontStyle: 'italic'}}>
//           {new Date().toLocaleDateString('en-GB', {
//             day: '2-digit',
//             month: 'short',
//             year: 'numeric',
//           })}{' '}
//           {new Date().toLocaleTimeString('en-US', {
//             hour: 'numeric',
//             minute: '2-digit',
//             hour12: true,
//           })}
//         </div>
//       </div>
//     </div>
//   );

//   const pageContainerStyle = {
//     width: '100%',
//     padding: '17px 28px',
//     position: 'relative',
//     boxSizing: 'border-box',
//     display: 'flex',
//     flexDirection: 'column',
//     zIndex: 1,
//     backgroundImage: `url(${pdfBg})`,
//     backgroundRepeat: 'no-repeat',
//     backgroundPosition: 'center',
//     backgroundSize: 'contain',
//   };

//   return (
//     <div className="pdf-export-container   !bg-[#FFFFFF]">
//       <PDFExport
//         ref={pdfExportComponent}
//         paperSize="A4"
//         margin="40px"
//         fileName="Account_Overview_Report.pdf"
//         author="Dojah"
//         scale={0.8}
//       >
//         <div style={pageContainerStyle}>
//           <Header />

//           <div style={{marginBottom: '16px'}}>
//             <h1
//               style={{fontSize: '16px', fontWeight: '500', marginBottom: '4px'}}
//             >
//               Flow overview
//             </h1>
//             <p style={{fontSize: '12px', color: '#080917', fontWeight: '500'}}>
//               Date Range:{' '}
//               <span style={{color: '#727272'}}>
//                 {accountData.dateRange || '28/3/2025 - 30/3/2025'}
//               </span>
//             </p>
//           </div>

//           <div style={{marginBottom: '10px'}}>
//             <div
//               style={{
//                 fontSize: '10px',
//                 fontWeight: '500',
//                 padding: '4px',
//                 backgroundColor: '#ECECEC',
//                 marginBottom: '4px',
//               }}
//             >
//               Event metrics
//             </div>
//             <table
//               style={{
//                 width: '100%',
//                 borderCollapse: 'collapse',
//                 fontSize: '10px',
//               }}
//             >
//               <tbody>
//                 <tr>
//                   <td
//                     style={{
//                       width: '15%',
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Total Events
//                   </td>
//                   <td style={{width: '70%', padding: '4px'}}>3000</td>
//                 </tr>
//                 <tr>
//                   <td
//                     style={{
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Pending Events
//                   </td>
//                   <td style={{padding: '4px'}}>500</td>
//                 </tr>
//                 <tr>
//                   <td
//                     style={{
//                       width: '15%',
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Allowed Events
//                   </td>
//                   <td style={{padding: '4px'}}>1100</td>
//                 </tr>
//                 <tr>
//                   <td
//                     style={{
//                       width: '15%',
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Blocked Events
//                   </td>
//                   <td style={{padding: '4px'}}>200</td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>

//           <div style={{marginBottom: '16px'}}>
//             <div
//               style={{
//                 fontSize: '10px',
//                 fontWeight: '500',
//                 padding: '4px',
//                 backgroundColor: '#ECECEC',
//                 marginBottom: '8px',
//               }}
//             >
//               Activity Summary
//             </div>

//             <div
//               style={{
//                 display: 'flex',
//                 flexDirection: 'row',
//                 justifyContent: 'space-between',
//                 marginBottom: '20px',
//                 flexWrap: 'wrap',
//                 gap: '14px',
//               }}
//             >
//               <div
//                 style={{
//                   flex: '1',
//                   minWidth: '250px',
//                   backgroundColor: '#F9F9F9',
//                   borderRadius: '6px',
//                   padding: '10px 12px 21px 12px',
//                 }}
//               >
//                 <h3
//                   style={{
//                     fontSize: '14px',
//                     fontWeight: '600',
//                     marginBottom: '10px',
//                     textAlign: 'left',
//                   }}
//                 >
//                   Cases
//                 </h3>
//                 <div style={{display: 'flex', justifyContent: 'center'}}>
//                   <div
//                     style={{
//                       width: '200px',
//                       height: '200px',
//                       position: 'relative',
//                     }}
//                   >
//                     <Doughnut data={eventsData} options={chartOptions} />
//                     <div
//                       style={{
//                         position: 'absolute',
//                         top: '50%',
//                         left: '50%',
//                         transform: 'translate(-50%, -50%)',
//                         textAlign: 'center',
//                       }}
//                     >
//                       <div style={{fontSize: '16px', fontWeight: '500'}}>
//                         3,000
//                       </div>
//                       <div style={{fontSize: '10px', color: '#878787'}}>
//                         Total No of cases
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div
//                   style={{
//                     display: 'flex',
//                     justifyContent: 'center',
//                     flexDirection: 'column',
//                     gap: '10px',
//                     marginTop: '10px',
//                     flexWrap: 'wrap',
//                   }}
//                 >
//                   <div style={{display: 'flex', alignItems: 'center'}}>
//                     <div
//                       style={{
//                         width: '10px',
//                         height: '10px',
//                         backgroundColor: '#141738',
//                         borderRadius: '50%',
//                         marginRight: '5px',
//                       }}
//                     ></div>
//                     <span style={{fontSize: '11px', color: '#4F555F'}}>
//                       RESOLVED CASES
//                     </span>
//                     <span
//                       style={{
//                         fontSize: '11px',
//                         marginLeft: '4px',
//                       }}
//                     >
//                       (48%)
//                     </span>
//                   </div>
//                   <div
//                     style={{
//                       display: 'flex',
//                       alignItems: 'center',
//                     }}
//                   >
//                     <div
//                       style={{
//                         width: '10px',
//                         height: '10px',
//                         backgroundColor: '#3F7CDB',
//                         borderRadius: '50%',
//                         marginRight: '5px',
//                       }}
//                     ></div>
//                     <span style={{fontSize: '11px', color: '#4F555F'}}>
//                       UNRESOLVED CASES
//                     </span>
//                     <span
//                       style={{
//                         fontSize: '11px',
//                         marginLeft: '4px',
//                       }}
//                     >
//                       (50%)
//                     </span>
//                   </div>
//                 </div>
//               </div>

//               <div
//                 style={{
//                   flex: '1',
//                   minWidth: '250px',
//                   backgroundColor: '#F9F9F9',
//                   borderRadius: '6px',
//                   padding: '10px 12px 21px 12px',
//                 }}
//               >
//                 <h3
//                   style={{
//                     fontSize: '14px',
//                     fontWeight: '600',
//                     marginBottom: '10px',
//                     textAlign: 'left',
//                   }}
//                 >
//                   Resolved Cases
//                 </h3>
//                 <div style={{display: 'flex', justifyContent: 'center'}}>
//                   <div
//                     style={{
//                       width: '200px',
//                       height: '200px',
//                       position: 'relative',
//                     }}
//                   >
//                     <Doughnut data={casesData} options={chartOptions} />
//                     <div
//                       style={{
//                         position: 'absolute',
//                         top: '50%',
//                         left: '50%',
//                         transform: 'translate(-50%, -50%)',
//                         textAlign: 'center',
//                       }}
//                     >
//                       <div style={{fontSize: '16px', fontWeight: '500'}}>
//                         200
//                       </div>
//                       <div style={{fontSize: '10px', color: '#878787'}}>
//                         Total No of resolved cases
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div
//                   style={{
//                     display: 'flex',
//                     justifyContent: 'center',
//                     flexDirection: 'column',
//                     gap: '10px',
//                     marginTop: '10px',
//                     flexWrap: 'wrap',
//                   }}
//                 >
//                   <div style={{display: 'flex', alignItems: 'center'}}>
//                     <div
//                       style={{
//                         width: '10px',
//                         height: '10px',
//                         backgroundColor: '#F3787A',
//                         borderRadius: '50%',
//                         marginRight: '5px',
//                       }}
//                     ></div>
//                     <span style={{fontSize: '11px', color: '#4F555F'}}>
//                       ALLOWED CASES
//                     </span>
//                     <span
//                       style={{
//                         fontSize: '11px',
//                         marginLeft: '4px',
//                       }}
//                     >
//                       (30%)
//                     </span>
//                   </div>
//                   <div
//                     style={{
//                       display: 'flex',
//                       alignItems: 'center',
//                     }}
//                   >
//                     <div
//                       style={{
//                         width: '10px',
//                         height: '10px',
//                         backgroundColor: '#A13E3F',
//                         borderRadius: '50%',
//                         marginRight: '5px',
//                       }}
//                     ></div>
//                     <span style={{fontSize: '11px', color: '#4F555F'}}>
//                       BLOCKED CASES
//                     </span>
//                     <span
//                       style={{
//                         fontSize: '11px',
//                         marginLeft: '4px',
//                       }}
//                     >
//                       (70%)
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </PDFExport>
//     </div>
//   );
// });

// FlowOverviewReport.displayName = 'FlowOverviewReport';

// export default FlowOverviewReport;

import React from 'react';

function FlowOverviewReport() {
  return <div></div>;
}

export default FlowOverviewReport;
